
const HeroSection = () => {
  return (
    <section className="py-20 md:py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-serif text-primary-dark mb-6 md:mb-8 leading-tight">
            Vous n'êtes <span className="text-primary">pas seul</span> dans vos projets
          </h1>
          <p className="text-base md:text-xl lg:text-2xl text-gray-dark font-light leading-relaxed">
            Chacun a ses projets, ses objectifs et ses besoins. De multiples solutions existent dans votre agglomération, mais vous n'en avez pas toujours connaissance. Notre mission est de fluidifier et faciliter la réalisation de tous vos projets du quotidien.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
